module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 357
// module chunks = 0